import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Word List", -1)
const _hoisted_2 = { class: "sm:tw-grid sm:tw-grid-cols-2 md:tw-grid-cols-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.words, (w) => {
        return (_openBlock(), _createElementBlock("div", {
          key: w.id
        }, _toDisplayString(w.value), 1))
      }), 128))
    ])
  ]))
}